var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBloquestensoblock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9d9d9d;}.cls-2{fill:#b8b8b7;}.cls-3{fill:#cfcfcf;}.cls-4{fill:none;}.cls-5{fill:#009ee2;}.cls-6{fill:#9c9b9b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1080,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 540,
    cy: 540,
    r: 457.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "933.21 304.24 358.81 636.87 82.33 470.37 659.41 151.39 933.21 304.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "356.83 958.82 82.33 808.84 82.33 470.37 356.83 633.47 356.83 958.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "930.55 625.88 356.83 958.82 356.83 633.47 933.21 304.24 930.55 625.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "365.24 571.44 187.96 468.92 388.13 352.5 446.34 519.95 365.24 571.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "387.64 351.77 387.64 555.89 561.06 456.28 387.64 351.77"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "625.75 425.24 448.47 322.71 648.64 206.29 706.85 373.75 625.75 425.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "648.14 205.56 648.14 411.02 821.57 310.07 648.14 205.56"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloquestensoblock);
export default __webpack_public_path__ + "static/media/bloques tensoblock.15db3459bed66407b8b456298b0e064a.svg";
export { ForwardRef as ReactComponent };